import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_XfXvmNMeu6mR: {
	id: 'prd_XfXvm2DEV2NMeu6mR'
	ident: 'prd_XfXvmNMeu6mR'
	sku: 'simple_workbook_bundle_36_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_6LePG2DEV2cmrzIp5'
		amount: 90
		amount_usd: 36
		currency: 'USD'
		amount_with_discount: 36
		discount: 54
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_XfXvmNMeu6mR, OneTimeProduct>
const prd_XfXvmNMeu6mR = { ident: 'prd_XfXvmNMeu6mR' } as typeof _prd_XfXvmNMeu6mR

export default prd_XfXvmNMeu6mR
